<template>
    <el-input
        :value="val"
        size="small"
        type="text"
        :class="$style.field"
        @input="onType"
    ></el-input>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            val: '',
            moneyReg: /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9]?)?$/,
        };
    },
    created() {
        if (this.value && this.value !== '') {
            this.val = this.value;
        }
    },
    methods: {
        onType(value) {
            // money value can include just number dot and comma, otherwise not allow to type
            if (value.replaceAll(/[\d.,]/g, '') === '') {
                this.val = value;
                this.$emit('onChange', value);
            }
        },
        isValid() {
            return this.moneyReg.test(this.val);
        },
    },
};
</script>

<style module lang="scss">
.field {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type='number'] {
        -moz-appearance: textfield;
    }
}
</style>
